// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-card .booking_header_button {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  padding: 10px 16px;
}
.booking-card .booking_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.booking-card .booking_header .booking_date {
  height: 40px;
  width: 30%;
}
.booking-card .booking_header .booking_title {
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  margin: 20px 0;
}
.booking-card .booking_tabs {
  overflow-y: hidden;
  overflow-x: auto;
  margin-bottom: 16px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f2f5;
  display: flex;
}
.booking-card .booking_tabs button {
  margin-right: 15px;
}
.booking-card .booking_tabs .border_none {
  border: none;
}

.booking-card-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100vh - 70px);
}

.container-fluid {
  flex: 1 0 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.container-fluid .table_main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 14%;
  margin: 36px 13px 16px 13px;
}
.container-fluid .table_main .empty {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 200%) !important;
}
.container-fluid .table_main .table_container {
  cursor: pointer;
  margin-bottom: 36px;
  display: flex;
  flex-direction: column;
  color: var(--text);
}
.container-fluid .table_main .table_container .table_chair_top {
  display: flex;
  gap: 8.81px;
}
.container-fluid .table_main .table_container .table_chair_top span {
  flex: 1 1;
  height: 16px;
  background: var(--chair_bg);
  border-radius: 10px 10px 0px 0px;
  margin-bottom: 6px;
}
.container-fluid .table_main .table_container .table_chair_bottom {
  display: flex;
  gap: 8.81px;
}
.container-fluid .table_main .table_container .table_chair_bottom span {
  flex: 1 1;
  height: 16px;
  background: var(--chair_bg);
  border-radius: 0px 0px 10px 10px;
  margin-top: 6px;
}
.container-fluid .table_main .table_container .table_card {
  position: relative;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--chair_bg);
  border-radius: 10px;
  font-size: 13px;
}
.container-fluid .table_main .table_container .table_card .label {
  z-index: 99 !important;
}
.container-fluid .table_main .table_container .table_card .table_chair_left {
  position: absolute;
  right: -22px;
  display: flex;
  flex-direction: column;
}
.container-fluid .table_main .table_container .table_card .table_chair_left span {
  transform: rotate(180deg);
  width: 16px;
  height: 25px;
  background: var(--chair_bg);
  border-radius: 10px 0px 0px 10px;
  margin-bottom: 6px;
}
.container-fluid .table_main .table_container .table_card .table_chair_right {
  position: absolute;
  left: -22px;
  display: flex;
  flex-direction: column;
}
.container-fluid .table_main .table_container .table_card .table_chair_right span {
  transform: rotate(180deg);
  width: 16px;
  height: 27px;
  background: var(--chair_bg);
  border-radius: 0px 10px 10px 0px;
  margin-bottom: 6px;
}

.table_booking {
  width: 100%;
}

.booking_footer {
  height: 70px;
  width: 100%;
  background: var(--anchor-wrapper-bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.booking_footer .booking_footer_statics {
  display: flex;
  align-items: center;
}
.booking_footer .booking_footer_statics .booking_text {
  margin-right: 28px;
  display: flex;
  gap: 6px;
}
.booking_footer .booking_footer_statics .booking_text .booking_circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.booking_footer .booking_footer_statics .booking_text p {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.3px;
  color: var(--text);
  padding: 0;
  margin: 0;
}
.booking_footer .booking_footer_statics h3 {
  border-right: 1px solid #000;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.3px;
  color: var(--body);
  padding-right: 14px;
  padding-left: 18px;
  margin: 0 14px 0 0;
}

.booking-history {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
.booking-history .booking-history-card {
  padding-bottom: 12px;
  border-bottom: 1px solid var(--anchor-before-bg);
}
.booking-history .booking-history-card:last-child {
  border: none;
}
.booking-history .booking-history-card .booking-history-title {
  margin-bottom: 20px;
}
.booking-history .booking-history-card .booking-history-list {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
.booking-history .booking-history-card .booking-history-list .booking-history-item {
  display: flex;
  align-items: center;
  column-gap: 12px;
}
.booking-history .booking-history-card .booking-history-list .booking-history-item .item-table {
  color: #fff;
  font-weight: 500;
  padding: 12px;
  border-radius: 6px;
}
.booking-history .booking-history-card .booking-history-list .booking-history-item .item-table.red {
  background-color: var(--badge-red);
}
.booking-history .booking-history-card .booking-history-list .booking-history-item .item-table.orange {
  background-color: var(--badge-orange);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/booking.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,YAAA;EACA,UAAA;AADN;AAII;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFN;AAME;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,aAAA;AAJJ;AAMI;EACE,kBAAA;AAJN;AAOI;EACE,YAAA;AALN;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;AAPF;;AAUA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,2BAAA;AAPJ;AASI;EACE,kBAAA;EACA,SAAA;EACA,2CAAA;AAPN;AAUI;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AARN;AAUM;EACE,aAAA;EACA,WAAA;AARR;AAUQ;EACE,SAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AARV;AAYM;EACE,aAAA;EACA,WAAA;AAVR;AAYQ;EACE,SAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,eAAA;AAVV;AAcM;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAZR;AAcQ;EACE,sBAAA;AAZV;AAeQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAbV;AAeU;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AAbZ;AAiBQ;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAfV;AAiBU;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AAfZ;;AAuBA;EACE,WAAA;AApBF;;AAuBA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AApBF;AAsBE;EACE,aAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,kBAAA;EACA,aAAA;EACA,QAAA;AApBN;AAsBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AApBR;AAuBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AArBR;AAyBI;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAvBN;;AA4BA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAzBF;AA2BE;EACE,oBAAA;EACA,gDAAA;AAzBJ;AA2BI;EACE,YAAA;AAzBN;AA4BI;EACE,mBAAA;AA1BN;AA6BI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AA3BN;AA6BM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA3BR;AA6BQ;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AA3BV;AA6BU;EACE,kCAAA;AA3BZ;AA8BU;EACE,qCAAA;AA5BZ","sourcesContent":[".booking-card {\n  .booking_header_button {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    padding: 10px 16px;\n  }\n\n  .booking_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .booking_date {\n      height: 40px;\n      width: 30%;\n    }\n\n    .booking_title {\n      font-weight: 600;\n      font-size: 22px;\n      line-height: 27px;\n      margin: 20px 0;\n    }\n  }\n\n  .booking_tabs {\n    overflow-y: hidden;\n    overflow-x: auto;\n    margin-bottom: 16px;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #f0f2f5;\n    display: flex;\n\n    button {\n      margin-right: 15px;\n    }\n\n    .border_none {\n      border: none;\n    }\n  }\n}\n\n.booking-card-main {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: calc(100vh - 70px);\n}\n\n.container-fluid {\n  flex: 1 0 50%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .table_main {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 14%;\n    margin: 36px 13px 16px 13px;\n\n    .empty {\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 200%) !important;\n    }\n\n    .table_container {\n      cursor: pointer;\n      margin-bottom: 36px;\n      display: flex;\n      flex-direction: column;\n      color: var(--text);\n\n      .table_chair_top {\n        display: flex;\n        gap: 8.81px;\n\n        span {\n          flex: 1;\n          height: 16px;\n          background: var(--chair_bg);\n          border-radius: 10px 10px 0px 0px;\n          margin-bottom: 6px;\n        }\n      }\n\n      .table_chair_bottom {\n        display: flex;\n        gap: 8.81px;\n\n        span {\n          flex: 1;\n          height: 16px;\n          background: var(--chair_bg);\n          border-radius: 0px 0px 10px 10px;\n          margin-top: 6px;\n        }\n      }\n\n      .table_card {\n        position: relative;\n        height: 68px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: var(--chair_bg);\n        border-radius: 10px;\n        font-size: 13px;\n\n        .label {\n          z-index: 99 !important;\n        }\n\n        .table_chair_left {\n          position: absolute;\n          right: -22px;\n          display: flex;\n          flex-direction: column;\n\n          span {\n            transform: rotate(180deg);\n            width: 16px;\n            height: 25px;\n            background: var(--chair_bg);\n            border-radius: 10px 0px 0px 10px;\n            margin-bottom: 6px;\n          }\n        }\n\n        .table_chair_right {\n          position: absolute;\n          left: -22px;\n          display: flex;\n          flex-direction: column;\n\n          span {\n            transform: rotate(180deg);\n            width: 16px;\n            height: 27px;\n            background: var(--chair_bg);\n            border-radius: 0px 10px 10px 0px;\n            margin-bottom: 6px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.table_booking {\n  width: 100%;\n}\n\n.booking_footer {\n  height: 70px;\n  width: 100%;\n  background: var(--anchor-wrapper-bg);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .booking_footer_statics {\n    display: flex;\n    align-items: center;\n\n    .booking_text {\n      margin-right: 28px;\n      display: flex;\n      gap: 6px;\n\n      .booking_circle {\n        width: 14px;\n        height: 14px;\n        border-radius: 50%;\n      }\n\n      p {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        letter-spacing: -0.3px;\n        color: var(--text);\n        padding: 0;\n        margin: 0;\n      }\n    }\n\n    h3 {\n      border-right: 1px solid #000;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 16px;\n      letter-spacing: -0.3px;\n      color: var(--body);\n      padding-right: 14px;\n      padding-left: 18px;\n      margin: 0 14px 0 0;\n    }\n  }\n}\n\n.booking-history {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n\n  .booking-history-card {\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--anchor-before-bg);\n\n    &:last-child {\n      border: none;\n    }\n\n    .booking-history-title {\n      margin-bottom: 20px;\n    }\n\n    .booking-history-list {\n      display: flex;\n      flex-direction: column;\n      row-gap: 16px;\n\n      .booking-history-item {\n        display: flex;\n        align-items: center;\n        column-gap: 12px;\n\n        .item-table {\n          color: #fff;\n          font-weight: 500;\n          padding: 12px;\n          border-radius: 6px;\n\n          &.red {\n            background-color: var(--badge-red);\n          }\n\n          &.orange {\n            background-color: var(--badge-orange);\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
